var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsRawFileIcon = function SvgDsRawFileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F677E",
    d: "M4.494 5.633c-.24.28-.207.7.072.94L6.464 8.2 4.566 9.827a.667.667 0 1 0 .868 1.012l2.489-2.133a.667.667 0 0 0 0-1.012L5.433 5.56a.667.667 0 0 0-.94.073M7.178 11.333c0-.368.298-.667.666-.667H11A.667.667 0 1 1 11 12H7.844a.667.667 0 0 1-.666-.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5F677E",
    fillRule: "evenodd",
    d: "M1.333 2.666a2 2 0 0 1 2-2h5.334a6 6 0 0 1 6 6v6.667a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2zm2-.666a.667.667 0 0 0-.666.666v10.667c0 .368.298.667.666.667h9.334a.667.667 0 0 0 .666-.667V6.666q0-.339-.047-.666h-1.953a2 2 0 0 1-2-2V2.047A5 5 0 0 0 8.667 2zm7.334.449a4.7 4.7 0 0 1 2.217 2.218h-1.55A.667.667 0 0 1 10.666 4z",
    clipRule: "evenodd"
  })));
};
export default SvgDsRawFileIcon;